module.exports = __webpack_public_path__ + "img/7.475a9cc3.jpg";